angular.module('aprima-core-ui').constant('uxConstants', {
    blurDebounceTime: 200,
    //use the same value as in hammer.js, they've mostly likely done the research on the appropriate value.
    doubleClickTime: 300,
    incrementalSaveTime: 1000,
    lazySrcThrottle: 300,
    searchDebounceTime: 300,
});
